import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import AddIcon16 from '@wix/da-ds/pkg/Icons/16x16/Add';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
const AddColumnButton = ({ className, onClick, disabled, biData })=>{
    const { t } = useTranslation();
    const isDsUpdate = useFlag('ds_update_btn_medium');
    return /*#__PURE__*/ React.createElement(TextButton, {
        variant: "edit-purple",
        size: "medium",
        icon: isDsUpdate ? AddIcon16 : AddIcon,
        onClick: onClick,
        disabled: disabled,
        className: className,
        "data-role": "edit-control",
        "aria-label": t('gruser.widgetbox.button.addColumn'),
        biData: biData
    }, t('gruser.widgetbox.button.addColumn'));
};
AddColumnButton.displayName = 'AddColumnButton';
export default AddColumnButton;

//# sourceMappingURL=AddColumnButton.js.map